import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { BannerActionsType } from '../actions';
import * as BannerActions from '../actions';
import { switchMap, map, catchError, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { OdooAPI } from 'src/app/services/odoo/services/odooAPI';
import { Store } from '@ngrx/store';
import { BannerState } from '../state';
import * as BannerSelectors from '../selectors';

@Injectable()
export class BannerEffects {
  constructor(
    private actions$: Actions,
    private odooAPI: OdooAPI,
    private BannerStore: Store<BannerState>,
    ) {}

  @Effect()
  loadHttp$ = this.actions$.pipe(
    ofType(BannerActionsType.LOAD_HTTP),
    switchMap((loadHTTPAction: BannerActions.LoadHttp) => {
      return of(loadHTTPAction.payload);
    }),
    withLatestFrom(     
      this.BannerStore.select(BannerSelectors.selectOffset),
      this.BannerStore.select(BannerSelectors.selectLimit),
      this.BannerStore.select(BannerSelectors.selectSearch),
    ),
    switchMap(([payload]) => {
      return this.odooAPI
        .loadPublicRecords(payload)
        .pipe(
          map(
            (data: any) => {
              return new BannerActions.LoadHttpSuccess(data);
            },
            err => {
              return new BannerActions.LoadHttpFail(err);
            }
          ),
        catchError(err => {
          return of(new BannerActions.LoadHttpFail(err));
        })
        )
    })
  );

  @Effect()
  loadPublicHttp$ = this.actions$.pipe(
    ofType(BannerActionsType.LOAD_PUBLIC_HTTP),
    switchMap((loadHTTPAction: BannerActions.LoadPublicHttp) => {
      return of(loadHTTPAction);
    }),
    switchMap((payload: any) => {
      
      return this.odooAPI.loadPublicRecords(payload).pipe(
        map(
          (data: any) => {
            
            return new BannerActions.LoadPublicHttpSuccess(data);
          },
          err => {
            return new BannerActions.LoadPublicHttpFail(err);
          }
        ),
        catchError((err: any) => {
          return of(new BannerActions.LoadPublicHttpFail(err));
        })
      );
    })
  );
  @Effect()
  updateSearch$ = this.actions$.pipe(
    ofType(BannerActionsType.UPDATE_SEARCH),
    switchMap((updateSearchAction: BannerActions.UpdateSearch) =>
      of(updateSearchAction.search)
    ),
    switchMap((search: any) => {
      return of(new BannerActions.LoadHttp({}));
    })
  );
}
